@if (showUploadFailureAlert() && imageUploadFailureError) {
  <se-fe-alert seFeDataType="error" role="alert" aria-atomic="true">
    {{ imageUploadFailureMessage }}
  </se-fe-alert>
}
@if (imageUploadLimitError) {
  <se-fe-alert
    seFeDataType="caution"
    [attr.role]="imageUploadLimitError ? 'alert' : null"
    [attr.aria-atomic]="imageUploadLimitError ? 'true' : null">
    {{ imageUploadLimitErrorMessage }}
    @if (imageUploadLimitSubheaderMessage) {
      <se-fe-alert-subheader>{{ imageUploadLimitSubheaderMessage }}</se-fe-alert-subheader>
    }
  </se-fe-alert>
}

<div
  class="multi-image-upload-field__uploader"
  [class.multi-image-upload-field__uploader--tall]="uploaderMinHeightPx() != null"
  [style.min-height.px]="uploaderMinHeightPx()">
  <se-fe-image-uploader
    #imageUploader
    [imageUploadLimitGuard]="remainingImageUploadSlots"
    seFeAcceptFormat="image/png, image/jpeg"
    [seFeDataDefaultImgUrl]="defaultImgUrl()"
    [seFeDataExistingAttachments]="existingAttachments"
    [seFeDataMultiple]="true"
    [seFeDataMaxFiles]="maxImageUploadCount()"
    (imageUploadLimitExceeded)="onImageUploadLimitExceeded($event)"
    (uploadSuccessMultiple)="onImageSuccess($event)"
    (uploadFailed)="onImageFailure()"
    (uploadCleared)="imageUploadCleared()"
    [seFeDataUploadedItemsHidden]="true"
    [seFeTestId]="{label: 'ImageUploader', isRoot: true}"></se-fe-image-uploader>
</div>

@if (imagesFormArray().length) {
  <div class="multi-image-upload-field__list">
    @if (canReorderImages()) {
      <div class="multi-image-upload-field__list-header">
        @if (isReorderingImages) {
          <se-fe-button seFeDataEmphasis="low" [seFeDataSmall]="true" (click)="finishImageReorder()">Done</se-fe-button>
        } @else {
          <se-fe-button seFeDataEmphasis="low" [seFeDataSmall]="true" (click)="startImageReorder()">
            Reorder
          </se-fe-button>
        }
      </div>
    }
    <div class="multi-image-upload-field__reorder-status" aria-live="polite" aria-atomic="true">
      {{ reorderStatusMessage }}
    </div>
    <div
      class="multi-image-upload-field__list-rows"
      cdkDropList
      cdkDropListOrientation="vertical"
      [cdkDropListData]="imagesFormArray().controls"
      [cdkDropListDisabled]="!isReorderingImages"
      (cdkDropListDropped)="dropImage($event)">
      @for (imgGroup of imagesFormArray().controls; track imgGroup) {
        <div class="multi-image-upload-field__row-host" cdkDrag [cdkDragDisabled]="!isReorderingImages">
          <div class="multi-image-upload-field__row">
            <img
              class="multi-image-upload-field__thumb"
              [src]="getSrcControlValue(imgGroup)"
              [alt]="getAltControlValue(imgGroup)"
              width="76"
              height="76" />
            <se-fe-form-field
              class="multi-image-upload-field__description"
              [seFeDataConfig]="getImageDescriptionConfig($index)">
              <se-fe-form-field-text
                [formControl]="getAltControl(imgGroup)"
                seFeDataAutoComplete="off"></se-fe-form-field-text>
            </se-fe-form-field>
            <input type="hidden" [formControl]="getSrcControl(imgGroup)" />
            <div class="multi-image-upload-field__actions">
              @if (isReorderingImages) {
                <se-fe-icon-button
                  cdkDragHandle
                  seFeDataEmphasis="medium"
                  [seFeTooltipTrigger]="reorderTooltip"
                  (keydown)="handleReorderKeydown($event, $index)"
                  [seFeDataButtonAttrs]="{
                    'aria-label':
                      'Move image ' + ($index + 1) + ' of ' + imagesFormArray().length + '. Use arrow keys to reorder.',
                  }">
                  <se-fe-icon
                    seFeDataName="grip_vertical"
                    seFeDataSize="500"
                    [seFeDataAriaLabel]="
                      'Move image ' + ($index + 1) + ' of ' + imagesFormArray().length + '. Use arrow keys to reorder.'
                    "
                    [seFeDataMargin]="false"></se-fe-icon>
                </se-fe-icon-button>
                <se-fe-tooltip #reorderTooltip>Reorder image</se-fe-tooltip>
              } @else {
                <se-fe-icon-button
                  seFeDataEmphasis="medium"
                  [seFeTooltipTrigger]="removeTooltip"
                  (click)="removeImage($index)"
                  [seFeDataButtonAttrs]="{'aria-label': 'Remove image ' + ($index + 1)}">
                  <se-fe-icon
                    seFeDataName="close"
                    seFeDataSize="500"
                    [seFeDataAriaLabel]="'Remove image ' + ($index + 1)"
                    [seFeDataMargin]="false"></se-fe-icon>
                </se-fe-icon-button>
                <se-fe-tooltip #removeTooltip>Remove image</se-fe-tooltip>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (showDescriptionHelp()) {
      <se-fe-form-control-help>
        Hint: this text will often include your product name and any other variant information apparent in the image
      </se-fe-form-control-help>
    }
  </div>
}
